/* unplugin-vue-components disabled */import script from "./CourseDesignDetailContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseDesignDetailContent.vue?vue&type=script&setup=true&lang=ts"

import "./CourseDesignDetailContent.vue?vue&type=style&index=0&id=7a30f3e6&scoped=true&lang=css"
import "./CourseDesignDetailContent.vue?vue&type=style&index=1&id=7a30f3e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a30f3e6"]])

export default __exports__